import {
  getPlatformURL,
  isStripeDomain,
} from '@stripe-internal/connect-embedded-lib';
import {disableAnalyticsParamName} from '../data-layer-client/buildDataLayerFrame';
import {getFlagOverrides} from '../utils/flags/flagOverrides';
import {getSearchParams} from '../utils/searchParams/getSearchParams';

let isAnalyticsDisabledCalculatedValue: boolean | undefined;

export const initializeIsAnalyticsDisabled = (
  isAnalyticsDisabledFromFrameInit: boolean | undefined = undefined,
) => {
  const currentUrl = new URL(getPlatformURL());
  const stripeDomain = isStripeDomain(currentUrl);

  if (isAnalyticsDisabledFromFrameInit && stripeDomain) {
    return true;
  }

  // This may be specified as a URL query param (in the platform frame), or as a hash param (in the ui layer frame)
  // We handle both in this method. This is only allowed in internal domains
  const searchParams = getSearchParams();
  const isAnalyticsDisabledInUrl =
    searchParams.get(disableAnalyticsParamName) === 'true';

  if (isAnalyticsDisabledInUrl && stripeDomain) {
    return true;
  }

  const flagOverrides = getFlagOverrides();

  // If there are flag overrides, we disable analytics as we don't want to alert when adhoc features are on/off
  const hasFlagOverrides = Object.keys(flagOverrides).length > 0;
  if (hasFlagOverrides) {
    return true;
  }

  return false;
};

export function isAnalyticsDisabled(
  isAnalyticsDisabledFromFrameInit: boolean | undefined = undefined,
): boolean {
  if (isAnalyticsDisabledCalculatedValue !== undefined) {
    return isAnalyticsDisabledCalculatedValue;
  }

  isAnalyticsDisabledCalculatedValue = initializeIsAnalyticsDisabled(
    isAnalyticsDisabledFromFrameInit,
  );
  return isAnalyticsDisabledCalculatedValue;
}
